import * as TypeDefinitions from './types/index.js';
TypeDefinitions;
export { TypeDefinitions };
export function isTypeInCategory(type, category) {
    return TypeDefinitions[type].category == category;
}
export function isTypeElementAspect(type) {
    for (var property in TypeDefinitions) {
        const def = TypeDefinitions[property];
        if ('aspects' in def && def.aspects.some((t) => t == type))
            return true;
    }
    return false;
}
export function getAspects(type) {
    const definition = TypeDefinitions[type];
    if (definition.category == 'element') {
        return definition.aspects;
    }
    return [];
}
export function getForms(type) {
    const definition = TypeDefinitions[type];
    if ('forms' in definition) {
        return definition.forms;
    }
    return [];
}
//# sourceMappingURL=definition.js.map